import { isArray, isNumber, isObject, isString } from './validate';

interface Option {
  colKey?: string;
  colValue?: string;
}

export function arr2Obj(list: any, option: Option = {}) {
  if (!isArray(list)) return isObject(list) === list ? list : {};
  const { colKey = 'label', colValue = 'value' } = option;
  const ret: Record<string, string | number> = {};
  list.forEach((data, index) => {
    if (isString(data) || isNumber(data)) {
      ret[index] = data;
    } else {
      ret[data[colValue]] = data[colKey];
    }
  });
  return ret;
}

export function obj2Array(obj: Record<string, any>, option: Option = {}) {
  if (!isObject(obj)) return isArray(obj) ? obj : [];
  const { colKey = 'label', colValue = 'value' } = option;
  const ret = [];
  const keys = Object.keys(obj);
  for (const key of keys) {
    ret.push({
      [colKey]: obj[key],
      [colValue]: key
    });
  }
  return ret;
}

export function arr2Options(list: any, option: Option = {}) {
  if (!isArray(list)) return [];
  const { colKey = 'label', colValue = 'value' } = option;

  return list.map(data => ({
    label: data[colKey],
    value: data[colValue]
  }));
}
